module.exports = __webpack_public_path__ + "static/img/s13.78b9e88.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/s13.png
// module id = BKac
// module chunks = 0